import { useTranslation } from "react-i18next";
import { useHeaderHeight } from "../../hooks/useHeaderHeight";
import GoogleMiniMap from "../Map";

export const ProductMap = ({ d }: { d?: ProductDetailResponse }) => {
  const { headerHeight } = useHeaderHeight();
  const { t } = useTranslation();
  if (!d?.addressLat || !d?.addressLng) return null;
  return (
    <div className="mt-10">
      <div style={{ top: headerHeight || 0 }}>
        <div className="mb-[0.5rem]">
          <GoogleMiniMap
            defaultCenter={{
              lat: Number(d.addressLat) || 0,
              lng: Number(d.addressLng) || 0,
            }}
            width="auto"
            height="14.125rem"
            clickToMarker={false}
          />
        </div>
        <p className="text-sm font-normal leading-[1.5rem] text-[#232323]">
          {t("Address")}: {d?.address || ""}
        </p>
      </div>
    </div>
  );
};
